import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import { configureStore } from './redux/store'
import { Provider as StoreProvider } from 'react-redux'
import App from './App'
import * as serviceWorker from './serviceWorker'

const store = configureStore()

ReactDOM.render(
  <StoreProvider store={store}>
    <App />
  </StoreProvider>,
  document.getElementById('root')
)

serviceWorker.unregister()
